// extracted by mini-css-extract-plugin
module.exports = {"root":"PlasmicDisabilityItem_root__Uo5G6","freeBox":"PlasmicDisabilityItem_freeBox__2yDRW","ratingHolder":"PlasmicDisabilityItem_ratingHolder__hi52C"};